export default __webpack_public_path__ + "static/media/BG-Green-0005.ddc773a9.png";